import { render, staticRenderFns } from "./DictText.vue?vue&type=template&id=43f55110&scoped=true"
import script from "./DictText.vue?vue&type=script&lang=js"
export * from "./DictText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f55110",
  null
  
)

export default component.exports